import { Box } from "@mui/material";
import { Handle, type NodeProps, Position } from "@xyflow/react";
import { RULE_GRAPH_NODE_HEIGHT, RULE_GRAPH_RESULT_WIDTH } from "./layout";
import { RuleGraphCartInput } from "./RuleGraphCartInput";
import { RUN_WALK_LAND_MS } from "./run-walk";
import { RULE_GRAPH_CART_INPUT_NODE_ID } from "./types";
import type { RuleGraphCartInputFlowNode } from "./ruleGraphNodeData/RuleGraphCartInputFlowNode";
import { REDUCED_MOTION } from "./ruleGraphReducedMotion";
import { runLand } from "./ruleGraphRunLand";
import { useNodeMeasurement } from "./useNodeMeasurement";

export const RuleGraphCartInputNode = ({
  data,
}: NodeProps<RuleGraphCartInputFlowNode>) => {
  const rootRef = useNodeMeasurement<HTMLDivElement>(
    RULE_GRAPH_CART_INPUT_NODE_ID,
    data.onMeasure
  );
  return (
    <Box
      ref={rootRef}
      aria-label="Cart input"
      className="nodrag nopan"
      data-active={data.isActive ? "true" : undefined}
      data-kind="cart-input"
      role="group"
      sx={{
        alignItems: "flex-start",
        display: "flex",
        flexDirection: "column",
        minHeight: RULE_GRAPH_NODE_HEIGHT,
        // Content-sized like the shopper-sees panel: centered on the card row
        // it sits beside and allowed to run past that row's height.
        justifyContent: "center",
        overflow: "visible",
        width: RULE_GRAPH_RESULT_WIDTH,
        animation: data.isActive
          ? `${runLand} ${RUN_WALK_LAND_MS}ms ease-out`
          : "none",
        [REDUCED_MOTION]: { animation: "none" },
      }}
    >
      <RuleGraphCartInput cartInput={data.cartInput} />
      <Handle
        id="flow-source"
        type="source"
        position={Position.Right}
        isConnectable={false}
        style={{ opacity: 0 }}
      />
    </Box>
  );
};
